import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { TextAlignKinds } from "../../../../base/domain/drawing";
import {
  IEditBehavior,
  IInputMethodBehavior,
  InputMethodKinds,
  ITurnedTextStyle,
  TranscribeTargetKinds,
} from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { ITagObject } from "../objects";
import {
  IEditBehaviorPropertyEditable,
  IInputMethodBehaviorPropertyEditable,
  ITurnedTextStylePropertyEditable,
} from "../properties";
import { AbstractStandardTextDrawableObjectEditor } from "./AbstractStandardTextDrawableObjectEditor";

export class TagObjectEditor extends AbstractStandardTextDrawableObjectEditor<ITagObject> implements
IEditBehaviorPropertyEditable,
IInputMethodBehaviorPropertyEditable,
ITurnedTextStylePropertyEditable {
  constructor(source: ITagObject | TagObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._text = this.createTextPropertyEditor();
    this._editBehavior = this.createPropertyEditor(s => s.editBehavior, (s, v) => s.editBehavior = v);
    this._inputRuleBehavior = this.createInputRuleBehaviorPropertyEditor();
    this._inputMethodBehavior = this.createPropertyEditor(s => s.inputMethodBehavior, (s, v) => s.inputMethodBehavior = v);
    this._turnedTextStyle = this.createPropertyEditor(s => s.turnedTextStyle, (s, v) => s.turnedTextStyle = v);
    this._scriptExecuteTriggerBehavior = this.createScriptExecuteTriggerBehaviorPropertyEditor(s => true);
    this._emptyAlertAllowBehavior = this.createEmptyAlertAllowBehaviorPropertyEditor(s => true);
    this._groupAlertAllowBehavior = this.createGroupAlertAllowBehaviorPropertyEditor(s => true);
    this._lineBreakBehavior = this.createLineBreakBehaviorPropertyEditor(s => true);
  }

  protected _editBehavior: IPropertyEditable<IEditBehavior>;
  protected _inputMethodBehavior: IPropertyEditable<IInputMethodBehavior>;
  protected _turnedTextStyle: IPropertyEditable<ITurnedTextStyle>;

  editBehavior(): IPropertyEditable<IEditBehavior> {
    return this._editBehavior;
  }

  inputMethodBehavior(): IPropertyEditable<IInputMethodBehavior> {
    return this._inputMethodBehavior;
  }

  getSelectableInputMethods(): InputMethodKinds[] {
    return this._specification.objects.tag.inputMethods;
  }

  turnedTextStyle(): IPropertyEditable<ITurnedTextStyle> {
    return this._turnedTextStyle;
  }

  getTypeName(): string {
    return "テキストボックス";
  }

  getSelectableAlignmentKinds(): TextAlignKinds[] {
    return this._specification.objects.tag.alignmentKinds;
  }

  getWarningName(): string {
    return this._name.getValue();
  }

  getWarningSettingName(): string {
    return this._name.getValue();
  }

  isSettableWarningName(): boolean {
    return true;
  }

  getSelectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this._specification.objects.tag.transcription.targets;
  }

  clone(): IFormatObjectEditable {
    return new TagObjectEditor(this);
  }
}
